var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.304688 0.91723H8.15512L7.16881 3.87982H3.48228V7.19224H8.15512V10.156H0.304688V0.916016V0.91723Z",
    fill: "white"
  })));
};

export default __webpack_public_path__ + "static/media/cosentino-global-icon-c.7f3097e7.svg";
export { SvgComponent as ReactComponent };